// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1529":"74a4c280","3344":"f93e9e7d"}[chunkId] + ".chunk.css";
};